<div class="outer-container">
  <div class="form-container">
    <div class="left-column">
      <div class="contact-us-text">CONTACT US</div>
      <hr />
      <div class="contact-method">Email</div>
      <div>info&#64;verticaltalentgroup.com</div>
    </div>
    <div *ngIf="!showPostSubmitMessage" class="right-column">
      <div class="form-item">
        <label for="firstName">Name</label>
        <input [(ngModel)]="model.name" title="First Name" type="text" id="firstName" name="firstName" />
      </div>
      <div class="form-item">
        <label for="email">Email</label>
        <input [(ngModel)]="model.email" title="Email" type="text" id="email" name="email" />
      </div>
      <div class="form-item">
        <label for="handle">Social Media Handle</label>
        <input [(ngModel)]="model.handle" title="Handle" type="text" id="handle" name="handle" />
      </div>
      <div class="form-item">
        <label for="message">Message</label>
        <textarea [(ngModel)]="model.message" title="message" id="message" name="message" rows="10" cols="55"></textarea>
      </div>
      <div class="form-item">
        <button class="site-button black" (click)="submit()" [disabled]="disableSubmit">Submit</button>
      </div>
    </div>
    <div *ngIf="showPostSubmitMessage" class="right-column">
      <div class="message-submitted">
        <div>Message Submitted</div>
        <div>We will get back to you shortly</div>
      </div>
    </div>
  </div>
</div>
